import React from 'react';
import { useFormContext } from 'react-hook-form';

interface InputFieldProps {
  name: string;
  label: string;
  type: string;
  disabled?: boolean;
  required?: boolean;
  currentValue?: string;
}

const InputField: React.FC<InputFieldProps> = ({ name, label, type, disabled, currentValue }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="input-wrapper">
      <label className="settings-modal__input input-label" htmlFor={name}>
        {label}
        <input
          {...register(name)}
          defaultValue={currentValue || ''}
          type={type}
          name={name}
          disabled={disabled}
          className={`input input--medium ${errors[name] ? 'error' : ''}`}
        />
        {errors[name] && (
          <div className="input__error input-error basic-14">
            {errors[name]?.message && (
              <p className="input__error input-error basic-14">{errors[name]?.message?.toString() ?? ''}</p>
            )}
          </div>
        )}
        <p className="input__error input-error basic"></p>
      </label>
    </div>
  );
};

export default InputField;
